import LineInterface from 'app/interfaces/LineInterface';

export const isAdvantageLine = (line: LineInterface): boolean => line.type === 'Advantage';
